import { render, staticRenderFns } from "./ClientPackageList.vue?vue&type=template&id=393c19da"
import script from "./ClientPackageList.vue?vue&type=script&lang=js"
export * from "./ClientPackageList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports